import React from 'react';
import styles from './dash.module.css';

interface DashProps {
    onTouchEnd?: () => void;
}

const Dash = ({ onTouchEnd }: DashProps) => {
    return (
        <div
            className={styles.dashWrapper}
            onClick={(e: React.MouseEvent) => {
                if (onTouchEnd) {
                    e.preventDefault();
                    onTouchEnd();
                }
            }}
            onTouchEnd={(e) => {
                if (onTouchEnd) {
                    e.preventDefault();
                    onTouchEnd();
                }
            }}
        >
            <div className={styles.dashStyled} />
        </div>
    );
};

export default Dash;
